module.exports = __webpack_public_path__ + "static/media/icon-space.068e8ab1.jpg";